var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('h3',{staticClass:"centre"},[_vm._v("Payment "+_vm._s(_vm.result)+", redirecting to order detail...")])])}
var staticRenderFns = []

export { render, staticRenderFns }